import { TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTableRow = styled(TableRow)(({ theme }) => ({
    background: theme.palette.grey[50],
    borderRadius: theme.spacing(0.5),
}));

export { PeekTableRow, PeekTableRow as default };
